import React from 'react';
import { Box, Typography } from '@mui/material';

interface InfoRowProps {
  label: string;
  value: string | number | null;
  small?: boolean;
}

const InfoRow = ({ label, value, small = false }: InfoRowProps) => {
  if (value === null || value === undefined) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        mb: small ? 0.5 : 1,
      }}
    >
      <Typography
        variant={small ? 'caption' : 'body2'}
        sx={{ fontWeight: 'bold', color: 'text.secondary', mr: 2 }}
      >
        {label}:
      </Typography>
      <Typography
        variant={small ? 'caption' : 'body2'}
        sx={{ textAlign: 'right', flex: 1 }}
      >
        {value}
      </Typography>
    </Box>
  );
};

export default InfoRow;
